import React from "react";
import {
  FaGithub,
  FaLinkedinIn,
} from "react-icons/fa";
import profile from "../../../images/profile.jpeg";

const socials = [
  {
    id: 1,
    icon: <FaGithub />,
    link: "https://github.com/istili",
  },
  {
    id: 2,
    icon: <FaLinkedinIn />,
    link: "https://www.linkedin.com/in/ikram-stili-858648234/",
  }
];

const Sidebar = () => {
  return (
    <aside className="sticky top-0 bg-white md:mx-8 lg:mx-4 mb-8 p-6 shadow-md rounded-md -mt-40">
      <div className="w-24 h-24 rounded-md overflow-hidden mx-auto mb-5">
        <img src={profile} alt="shafiqhammad" className="w-full" />
      </div>
      <div className="text-center">
        <h1 className="text-xl text-gray-800 font-bold mb-1">Stili Ikram</h1>
        <p className="text-sm text-gray-400 mb-3">
          Full Stack Developer at
          <a href="#0" className="text-purple-600 pl-1">
            1337 coding school (42 Network)
          </a>
        </p>
        <a
          href="/resume_istili.pdf"
          className="inline-block mb-3 rounded bg-purple-600 text-center border-0 py-2 px-6 text-white leading-7 tracking-wide hover:bg-purple-800"
          download="Resume"
        >
          Download Resume
        </a>
        <ul className="flex flex-wrap justify-center">
          {socials.map((social, id) => (
            <SocialIcon social={social} key={id} />
          ))}
        </ul>
      </div>
      <div className="text-start pt-4">
        <h3 className="text-md mb-2 uppercase font-medium text-gray-800">
          About Me
        </h3>
        <p className="text-gray-400 text font-light leading-relaxed">
          I'm a student at 42 School, currently beyond the Common Core curriculum. The 42 program is project based and peer led, with no traditional teachers or lectures. This taught me self discipline, debugging, and how to learn new technologies quickly on my own.
Skills: C, C++, JS/TS shell scripting, Git, algorithms, memory management, network programming, and teamwork through peer reviews.
Strengths: I don't wait for instructions. I research, experiment, and solve problems independently. I'm comfortable with long debugging sessions and strict coding standards.
Education: 42 School completed Common Core (C, Unix, algorithms, data structures). Now working on advanced projects.
        </p>
      </div>
    </aside>
  );
};

export default Sidebar;

const SocialIcon = (props) => {
  const { icon, link } = props.social;
  return (
    <li className="m-2">
      <a
        href={link}
        className="w-8 h-8 bg-purple-100 rounded text-purple-800 flex items-center justify-center hover:text-white hover:bg-purple-600"
      >
        {icon}
      </a>
    </li>
  );
};
